import { debounce } from '@navi/web-ui/lib/utils';
import { naviExtension } from 'src/service/naviExtension.service';
import { addAmeyoAvailabilityToggleClickstream } from '../service/ameyo.service';
import { isFunction } from '@cp/utils/commonUtils';

// file.start();

export const enum EXTENSION_LISTENER_TYPES {
  'onCallInComing',
  'onCallConnected',
  'onCallRejected',
  'onCallDisConnected',
  'onAvailabilityChange',
  'onError',
  'onAmeyoStateChange',
  onAmeyoCallStatusChanged,
  'campaignId',
  'multipleCampaignsNextButtonClicked',
  'toggleAmeyoStatus',
  'ameyoErroneous',
  'ameyoGenericClickstream',
  'ameyoBackgroundTabOpened',
  'ameyoTabOpeningAttempt',
  'ameyoBackgroundTabOpenFailed',
  'manualLogin',
  'extensionToggleMidCallClickEvent',
  'ameyoReloaded',
  'recieveCallStatus',
  'acceptCallError',
  'sendCurrentCallStatus',
  'sendCurrentCallStatusAndRecalibrate',
  'focusChromeExtensionsPage',
  'acceptCallClickFailure',
  'rejectCallClickFailure',
  'disconnectCallClickFailure',
  'disposeCallClickFailure'
}

export const ExtensionHelper = {
  addExtensionListener: (type: EXTENSION_LISTENER_TYPES, cb: Function) => {
    switch (type) {
      case EXTENSION_LISTENER_TYPES.onCallInComing: {
        naviExtension.registerCallBack({ onCallIncoming: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.onCallConnected: {
        naviExtension.registerCallBack({ onCallConnected: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.onCallRejected: {
        naviExtension.registerCallBack({ onCallRejected: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.onCallDisConnected: {
        naviExtension.registerCallBack({ onCallDisconnected: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.onAvailabilityChange: {
        naviExtension.registerCallBack({ onAvailabilityChange: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.onError: {
        naviExtension.registerCallBack({ onError: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.onAmeyoStateChange: {
        naviExtension.registerCallBack({ onAmeyoStateChange: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.onAmeyoCallStatusChanged: {
        naviExtension.registerCallBack({ onAmeyoCallStatusChanged: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.campaignId: {
        naviExtension.registerCallBack({ campaignId: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.multipleCampaignsNextButtonClicked: {
        naviExtension.registerCallBack({ multipleCampaignsNextButtonClicked: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.toggleAmeyoStatus: {
        naviExtension.registerCallBack({ toggleAmeyoStatus: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.ameyoErroneous: {
        naviExtension.registerCallBack({ ameyoErroneous: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.ameyoGenericClickstream: {
        naviExtension.registerCallBack({ ameyoGenericClickstream: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.ameyoBackgroundTabOpened: {
        naviExtension.registerCallBack({ ameyoBackgroundTabOpened: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.ameyoTabOpeningAttempt: {
        naviExtension.registerCallBack({ ameyoTabOpeningAttempt: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.ameyoBackgroundTabOpenFailed: {
        naviExtension.registerCallBack({ ameyoBackgroundTabOpenFailed: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.manualLogin: {
        naviExtension.registerCallBack({ manualLogin: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.extensionToggleMidCallClickEvent: {
        naviExtension.registerCallBack({ onExtensionToggleMidCallClick: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.ameyoReloaded: {
        naviExtension.registerCallBack({ ameyoReloaded: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.recieveCallStatus: {
        naviExtension.registerCallBack({ recieveCallStatus: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.acceptCallError: {
        naviExtension.registerCallBack({ acceptCallError: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.sendCurrentCallStatus: {
        naviExtension.registerCallBack({ sendCurrentCallStatus: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.sendCurrentCallStatusAndRecalibrate: {
        naviExtension.registerCallBack({ sendCurrentCallStatusAndRecalibrate: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.acceptCallClickFailure: {
        naviExtension.registerCallBack({ acceptCallClickFailure: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.rejectCallClickFailure: {
        naviExtension.registerCallBack({ rejectCallClickFailure: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.disconnectCallClickFailure: {
        naviExtension.registerCallBack({ disconnectCallClickFailure: cb });
        return;
      }
      case EXTENSION_LISTENER_TYPES.disposeCallClickFailure: {
        naviExtension.registerCallBack({ disposeCallClickFailure: cb });
        return;
      }
      default: {
        return;
      }
    }
  }
};

// naviExtension.registerCallbacks({
//   onCallInComing: ExtensionHelper.onCallInComing(onCallInComing),
//   onCallConnected: (_phoneNumbe: number, _lan: string) => {},
//   onCallRejected: () => {},
//   onCallDisConnected: () => {},
//   onAvailabilityChange: (isAvailable: boolean) => {},
//   onError: ({ type, message }) => {}
// });

export const ExtensionHandler = {
  acceptCall: (callback?: () => void) => {
    naviExtension.acceptCall();
    // TODO : Remove if not required
    isFunction(callback) && callback();
  },
  rejectCall: (callBack?: () => void) => {
    naviExtension.rejectCall();
    callBack && typeof callBack === 'function' && callBack();
  },
  muteCall: (callBack?: () => void) => {
    naviExtension.muteCall();
    callBack && typeof callBack === 'function' && callBack();
  },
  unMuteCall: (callBack?: () => void) => {
    naviExtension.unMuteCall();
    callBack && typeof callBack === 'function' && callBack();
  },
  disconnectCall: (callBack?: () => void) => {
    naviExtension.disconnectCall();
    callBack && typeof callBack === 'function' && callBack();
  },
  setAvailability: debounce((online: boolean, clickStreamData?: Record<string, string>) => {
    naviExtension.setAvailability(online);
    addAmeyoAvailabilityToggleClickstream(online, clickStreamData);
  }, 100),
  login: (email: string, password: string) => {
    naviExtension.login(email, password);
  },
  logout: () => {
    naviExtension.logout();
    naviExtension.unregisterAllCallbacks();
  },
  disableAmeyo: () => {
    naviExtension.disableAmeyo(); // not used yet
  },

  disableExtensionToggle: (state: boolean) => {
    naviExtension.disableExtensionToggle(state);
  },
  enableAmeyo: () => {
    naviExtension.enableAmeyo(); // not used yet
  },
  updateIsPending: (updatedValue: boolean) => {
    localStorage.setItem('isPending', updatedValue.toString());
    //naviExtension.updateIsPending(updatedValue);
  },
  isAvailable: () => {
    return naviExtension.isAvailable();
  },
  currentAmeyoStatus: () => {
    return naviExtension.currentAmeyoStatus();
  },
  disposeCall: () => {
    return naviExtension.disposeCall();
  },
  focusAmeyoTab: () => {
    return naviExtension.focusAmeyotab();
  },
  currentCallStatus: () => {
    // Below code is for mocking
    // const acceptedAt = 1684816993420;
    // return { ringingAt: acceptedAt - 2000,  acceptedAt, disconnectedAt: acceptedAt + 5000 }
    return naviExtension.currentCallStatus();
  },
  resetCallStatus: () => {
    return naviExtension.resetCallStatus();
  },
  getIsPending: () => {
    return localStorage.getItem('isPending');
  },
  resetAllAmeyoData: () => {
    naviExtension.resetAllAmeyoData();
  },
  getCurrentCallStatus: () => {
    naviExtension.getCurrentCallStatus();
  },
  focusChromeExtensionsPage: () => {
    naviExtension.focusChromeExtensionsPage();
  },
  blockSlash: () => {
    naviExtension.blockSlash();
  },
  unblockSlash: () => {
    naviExtension.unblockSlash();
  }
};
